export type ChartHistoryFilterType = "all" | "1M" | "1W" | "1D";

export const SAMPLING_INTERVAL_MINUTES: Record<ChartHistoryFilterType, number> = {
  all: 720, // half day (12 * 60)
  "1M": 180, // 3 hours (3 * 60)
  "1W": 30, // 30 minutes
  "1D": 5, // 5 minutes
};

export const YES_NO_COLORS = [
  "#00AAA1", // Yes
  "#FF5A37", // No
];

export const MULTIPLE_COLORS = [
  "#4879FF",
  "#00CE97",
  "#FF7C48",
  "#E88EFF",
  "#00AAFF",
  "#C0C000",
  "#FF9C25",
  "#FF7DC6",
  "#00D2DD",
  "#8ECF00",
  "#FF6469",
  "#AA9BFF",
  "#86AFD3",
  "#B5BD8A",
  "#ECC100",
  "#CAA396",
  "#819CFF",
  "#8BBE8B",
  "#ABABAB",
  "#6EC2AD",
];

export const BACKGROUND_MULTIPLE_COLORS = [
  "#E7EFFF",
  "#E5FFF3",
  "#FFE4D9",
  "#FBEBFF",
  "#E9F7FF",
  "#F9FFE0",
  "#FFF1E0",
  "#FFE6F7",
  "#E1FFFF",
  "#F0FFE4",
  "#FFECEC",
  "#EEEBFF",
  "#E2EAF1",
  "#ECEEE2",
  "#FFF9D9",
  "#F0EADE",
  "#E3E9FF",
  "#E2EEE2",
  "#EEEEEE",
  "#DEEEEA",
];
